import qs from 'qs';
import Vue from 'vue';
import Router from 'vue-router';

import store from '../store';

Vue.use(Router);

// Layouts
import Layout from '../layouts/Layout';
import Auth from '../layouts/Auth';
import Children from '../layouts/Children';

// Auth components
import Login from '../views/Login';

// Home
import Home from '../views/Home';

// Routers
import persons from '../modules/persons/router';
import services from '../modules/services/router';
import orders from '../modules/orders/router';
import tiles from '../modules/tiles/router';
import employees from '../modules/employees/router';
import plannings from '../modules/plannings/router';
import tasks from '../modules/tasks/router';
import companies from '../modules/companies/router';
import ereporter from '../modules/ereporter/router';
import devices from '../modules/devices/Device/router';
import warehouse from '../modules/devices/Warehouse/router';
import subscriptions from '../modules/subscriptions/router';
import booking_resources from '../modules/booking_resources/router';
import booking_reservations from '../modules/booking_reservations/router';
import booking_schedule from '../modules/booking_schedule/router';
import buildings from '../modules/buildings/router';
import building_complexes from '../modules/building_complexes/router';
import users from '../modules/users/router';
import inhabitant_changes from '../modules/inhabitant_changes/router';
import smarthome from '../modules/smarthome/router';
import abo_services from '../modules/abo_services/router';
import holidays from '../modules/holidays/router';
import app_content from '../modules/app_content/router';
import request_vacations from '../modules/request_vacations/router';
import documents_links from '../modules/documents_links/router';
import documents_lists from '../modules/documents_lists/router';
import building_complexes_contracts from '../modules/building_complexes_contracts/router';

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      component: Layout,

      beforeEnter: (to, from, next) => {
        if (!localStorage.getItem('locale')) {
          localStorage.setItem('locale', process.env.VUE_APP_I18N_LOCALE);
        }
        store.commit('loading', false);
        next();
      },

      meta: {
        requiresAuth: true
      },

      children: [
        {
          path: '',
          name: 'home',
          component: Home
        },

        ...persons,
        ...employees,
        ...ereporter,
        ...request_vacations,
        ...devices,
        ...warehouse,
        ...tasks,
        ...companies,
        ...inhabitant_changes,
        ...smarthome,
        ...abo_services,
        ...holidays,
        ...building_complexes,
        ...buildings,
        ...users,
        ...documents_links,
        ...documents_lists,
        ...building_complexes_contracts,
        {
          path: 'app-layouts',
          component: Children,

          children: [
            {
              path: '',
              name: 'app-layouts',
              component: () =>
                import('../views/settings/app_layouts/AppLayouts.vue')
            }
          ]
        },
        {
          path: 'personal-inerests',
          component: Children,

          children: [
            {
              path: '',
              name: 'personal-inerests',
              component: () => import('@/modules/tags/pages/TagsPage.vue')
            }
          ]
        },
        {
          path: 'forms',
          component: Children,

          children: [
            {
              path: '',
              name: 'forms',
              component: () => import('@/modules/forms/pages/FormPage.vue')
            },
            {
              path: 'create',
              name: 'forms.create',
              component: () =>
                import('@/modules/forms/pages/FormCreatePage.vue')
            },
            {
              path: ':id/edit',
              name: 'forms.edit',
              component: () => import('@/modules/forms/pages/FormEditPage.vue'),
              props: route => ({
                id: Number(route.params.id)
              })
            },
            {
              path: ':id/show',
              name: 'forms.show',
              component: () => import('@/modules/forms/pages/FormShowPage.vue'),
              props: route => ({
                id: Number(route.params.id)
              })
            }
          ]
        },
        {
          path: 'communication-options',
          component: Children,

          children: [
            {
              path: '',
              name: 'communication-options',
              component: () =>
                import(
                  '@/modules/communication_options/pages/CommunicationOptionsPage.vue'
                )
            }
          ]
        },
        ...services,
        ...orders,
        ...subscriptions,
        ...booking_resources,
        ...booking_reservations,
        ...booking_schedule,
        {
          path: 'documents',
          component: Children,

          children: [
            {
              path: '',
              name: 'documents',
              component: () => import('../views/documents/Documents.vue')
            }
          ]
        },
        {
          path: 'posts',
          component: Children,

          children: [
            {
              path: '',
              name: 'posts',
              component: () => import('@/modules/posts/pages/PostsPage.vue')
            },
            {
              path: 'create',
              name: 'posts.create',
              component: () =>
                import('@/modules/posts/pages/PostCreatePage.vue')
            },
            {
              path: ':id/edit',
              name: 'posts.edit',
              component: () => import('@/modules/posts/pages/PostEditPage.vue'),
              props: route => ({
                id: Number(route.params.id)
              })
            }
          ]
        },
        {
          path: 'reports',
          component: Children,

          children: [
            {
              path: '',
              name: 'reports',
              component: () => import('@/modules/reports/pages/ReportsPage.vue')
            },
            {
              path: ':type',
              name: 'reports.export',
              component: () =>
                import('@/modules/reports/pages/ReportExportPage.vue'),
              props: route => ({
                type: route.params.type
              })
            }
          ]
        },
        {
          path: 'notifications',
          component: Children,

          children: [
            {
              path: '',
              name: 'notifications',
              component: () =>
                import('@/modules/notifications/pages/NotificationsPage.vue')
            },
            {
              path: 'create',
              name: 'notifications.create',
              component: () =>
                import(
                  '@/modules/notifications/pages/NotificationCreatePage.vue'
                )
            },
            {
              path: ':id',
              name: 'notifications.show',
              component: () =>
                import(
                  '@/modules/notifications/pages/NotificationShowPage.vue'
                ),
              props: route => ({
                id: Number(route.params.id)
              })
            },
            {
              path: ':id/edit',
              name: 'notifications.edit',
              component: () =>
                import(
                  '@/modules/notifications/pages/NotificationEditPage.vue'
                ),
              props: route => ({
                id: Number(route.params.id)
              })
            }
          ]
        },
        ...app_content,
        {
          path: 'apps',
          component: Children,

          children: [
            {
              path: '',
              name: 'apps',
              component: () => import('@/modules/apps/pages/AppsPage.vue')
            },
            {
              path: 'create',
              name: 'apps.create',
              component: () => import('@/modules/apps/pages/AppsCreatePage.vue')
            },
            {
              path: ':id',
              component: Children,
              children: [
                {
                  path: '',
                  name: 'apps.show',
                  component: () =>
                    import('@/modules/apps/pages/AppsShowPage.vue'),
                  props: route => ({
                    id: Number(route.params.id)
                  })
                },
                ...tiles
              ]
            }
          ]
        },
        ...plannings
      ]
    },

    {
      path: '/auth',
      component: Auth,

      beforeEnter: (to, from, next) => {
        if (!localStorage.getItem('locale')) {
          localStorage.setItem('locale', process.env.VUE_APP_I18N_LOCALE);
        }
        store.commit('loading', false);
        next();
      },

      children: [
        {
          path: 'login',
          name: 'login',
          component: Login
        },

        {
          path: 'logout',
          name: 'logout',
          component: () => import('../components/auth/Logout'),

          meta: {
            requiresAuth: true
          }
        }
      ]
    }
  ],

  parseQuery(query) {
    return qs.parse(query);
  },

  stringifyQuery(query) {
    const result = qs.stringify(query);

    return result ? '?' + result : '';
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/hasToken']) {
      next({
        name: 'login'
      });
    } else {
      if (!store.getters['auth/hasAbility']) {
        store.dispatch('auth/retrievePermissions').catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
      }
      store.dispatch('auth/getActualPermissions').catch(({ response }) => {
        this.handleErrorsByResponse(response);
      });

      next();
    }
  } else {
    next();
  }
});

export default router;
